module.exports = __webpack_public_path__ + "media/images/covid/icons/cashless-3f2a716f73768ff62ddf510c71c2a5eb.svg";